const marketingPhrases = [
  "Democratizando o acesso à justiça através de IA avançada. Obtenha orientações jurídicas precisas em segundos.",
  "Transformando desafios legais em soluções claras com a potência da inteligência artificial.",
  "Sua consultoria jurídica digital disponível 24/7. Acesse conhecimento legal quando precisar.",
  "Navegue pelo sistema jurídico com confiança. Respostas precisas em linguagem acessível.",
  "Simplificando a legislação brasileira com tecnologia de ponta para decisões mais seguras.",
  "Conectando cidadãos à justiça com IA que entende suas necessidades jurídicas reais.",
  "Dúvidas legais resolvidas instantaneamente. O poder da inteligência artificial ao seu dispor.",
  "Decodificando a complexidade legal em orientações práticas com nossa tecnologia inovadora.",
  "Torne o acesso à justiça uma realidade com assistência jurídica alimentada por IA.",
  "Encontre clareza jurídica em minutos, não em meses. Tecnologia a serviço da cidadania.",
  "Sua bússola no universo jurídico brasileiro. Navegue com precisão e confiança.",
  "Revolucionando o acesso legal com análises jurídicas geradas por IA de última geração.",
  "Entenda seus direitos sem complicações. Conhecimento jurídico simplificado pela tecnologia.",
  "Da dúvida à certeza em segundos. Orientação jurídica impulsionada por inteligência artificial.",
  "Justiça acessível para todos. Aproximando o direito brasileiro do cidadão comum.",
  "Descomplique o universo jurídico com respostas personalizadas baseadas na legislação atual.",
  "Informação legal confiável ao alcance de um clique. Decisões mais seguras em menos tempo.",
  "Tecnologia jurídica que traduz a lei para a linguagem do cotidiano. Simples assim.",
  "Ampliando o acesso à justiça com soluções digitais que entendem suas necessidades reais.",
  "Respostas jurídicas instantâneas e confiáveis. O futuro do direito disponível agora."
];

export default marketingPhrases;
